import cn from "classnames";
import { ARROW_POSITION, TooltipContentProps } from "./Tooltip.types";
import { TooltipArrow } from "../Icons";
import s from "./Tooltip.module.scss";

export const TooltipContent = ({ children, className, arrowPosition = ARROW_POSITION.BOTTOM }: TooltipContentProps) => {
  return (
    <div className={cn(s.tooltipContent, className)}>
      {children} <TooltipArrow className={cn(s.arrowBottom, s[arrowPosition])} />
    </div>
  );
};
